

import { Component, Vue } from 'vue-property-decorator';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";

@Component({
    components:{
        CheckBox,
        UnderlineForm
        
    }
})
export default class Form7 extends Vue {

    rightDocuments = [
       "Application About a Family Law Matter", 
       "Financial Statement",
       "Guardianship Affidavit",
       "Instructions about filing reply",
       "Application for Case Management Order",
       "Application About a Protection Order",
       "Application About Priority Parenting Matter"
    ];

    leftDocuments = [
        "Order", 
        "Reply to a Counter Application",
        "Application for Order Prohibiting the Relocation of a Child",
        "Application About Enforcement",
        "Written Response to Application",
        "Notice of Intention to Proceed",
        "Other (list any additional document(s) that you served here):"
    ];



}
